// extracted by mini-css-extract-plugin
export default {"main":"style_main__FQO16","mainClose":"style_mainClose__2QWLX style_main__FQO16","bg":"style_bg__t0khR"};